import { CircleAlert } from "lucide-react";
import type { FC } from "react";

import { useFormField } from "@/components/ui/form";
import { cn } from "@/lib/utils";
import { commonIconProps20 } from "@/utils/constants";

interface FieldErrorMessageProps {
  className?: string;
  message?: string;
}

const FieldErrorMessage: FC<FieldErrorMessageProps> = ({
  className,
  message,
}) => {
  const { error, formMessageId } = useFormField();
  const displayMessage = message ?? error?.message;

  if (!displayMessage) return null;

  return (
    <div
      id={formMessageId}
      data-slot="form-message"
      className={cn(
        "absolute bottom-[-22px] w-max flex items-center gap-1 text-sm text-destructive",
        className
      )}
    >
      <CircleAlert {...commonIconProps20} color="#DC2626" />
      <span>{String(displayMessage)}</span>
    </div>
  );
};

export default FieldErrorMessage;
